<template>
  <span :data-aid="actor.id">
    <font-awesome-icon v-if="actor.icon" :icon="actor.icon" class="mr-1" />
    <span v-if="getSingleVar">
      <template v-if="actor.component">
        <component
          v-bind:is="actor.component"
          :vars="getActorVars(actor)"
        />
      </template>
      <template v-else>
        <template v-if="isBoolean">
          <template v-if="onlyText">
            {{ getBooleanText }}
          </template>
          <template v-else>
            <font-awesome-icon
              icon="circle"
              :class="[getSingleVar.value
              ? 'text-success'
              : 'text-black-25'
            ]"
            />
          </template>
        </template>
        <template v-else>
          {{ getValueStrWithUnits }}
        </template>
      </template>
    </span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DisplayStatusValue',
  props: {
    actor: {
      type: Object,
      required: true,
    },
    onlyText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'getActorVars',
    ]),
    isBoolean() {
      return typeof this.getSingleVar.value === 'boolean';
    },
    getBooleanText() {
      return this.getSingleVar.value ? this.$t('turned-on') : this.$t('turned-off');
    },
    getSingleVar() {
      return this.getActorVars(this.actor)[0];
    },
    getValueStrWithUnits() {
      if (this.actor.dataType === 'scalar') {
        const { value } = this.getSingleVar;
        if (value !== undefined) {
          return `${value}${this.getSingleVar.unit ? this.getSingleVar.unit : ''}`;
        }
      }
      return 'N/A';
    },
  },
};
</script>

<style scoped>

</style>
